module.exports = __webpack_public_path__ + "assets/img/18_1799_big.61926b96.jpg";